import Icon from '@components/officialStore/common/Icon.vue'
import Select from '@components/officialStore/common/Select.vue'
import Button from '@components/officialStore/common/Button.vue'
import SelectGroup from '@components/officialStore/common/SelectGroup.vue'
import Input from '@components/officialStore/common/Input.vue'
import List from '@components/officialStore/common/List.vue'
import ListItem from '@components/officialStore/common/ListItem.vue'
import PayState from '@components/officialStore/common/PayState.vue'
import Editor from '@components/officialStore/common/Editor.vue'
import PopupWindow from '@components/officialStore/common/PopupWindow.vue'
import LoaddingPage from '@components/officialStore/common/LoaddingPage.vue'
import DataList from '@components/officialStore/common/DataList.vue'

export default {
  install(Vue) {
    Vue.component('Icon', Icon)
    Vue.component('Select', Select)
    Vue.component('Button', Button)
    Vue.component('SelectGroup', SelectGroup)
    Vue.component('InputComp', Input)
    Vue.component('List', List)
    Vue.component('ListItem', ListItem)
    Vue.component('PayState', PayState)
    Vue.component('Editor', Editor)
    Vue.component('PopupWindow', PopupWindow)
    Vue.component('LoaddingPage', LoaddingPage)
    Vue.component('DataList', DataList)
  }
}
